import { Color } from "@react-three/fiber";
import { Transform3D } from "../../types";

export enum LightType {
  AmbientLight = "Ambient",
  PointLight = "Point",
  AreaLight = "Area",
  SpotLight = "Spot",
}

export type LightKey = keyof typeof LightType;
export type LightValue = typeof LightType[LightKey];

export type LightProps = Transform3D & {
  intensity?: number;
  color?: Color;
  distance?: number;
  decay?: number;
};

// These are the props that will be drilled from contentful
export type SceneLightProps = {
  transform3D?: Transform3D;
  lightType: LightValue;
  intensity?: number;
  hexColor?: string;
  distance?: number;
  decay?: number;
};
